import { Moon, Sun, Monitor, ArrowLeftRight } from "lucide-react";
import { cn } from "@pineseed/gui/util/utils";
import { useTheme } from "@pineseed/gui/hook/useTheme";

export function ThemeToggle({ className }: { className?: string }) {
  const { themePreference, setThemePreference, systemInverted, setSystemInverted } = useTheme();

  const themeIcon =
    themePreference === "dark" ? <Moon size={16} />
    : themePreference === "light" ? <Sun size={16} />
    : <Monitor size={16} />;

  const cycleTheme = () => {
    const next =
      themePreference === "system"
        ? "light"
        : themePreference === "light"
          ? "dark"
          : "system";
    setThemePreference(next);
  };

  const btn = "opacity-50 hover:opacity-100 transition-all p-1 rounded-md flex items-center shadow-[0_0_3px_0_rgba(0,0,0,0.06)] dark:shadow-[0_0_3px_0_rgba(255,255,255,0.04)]";

  return (
    <div className={cn("flex items-center gap-1", className)}>
      {themePreference === "system" && (
        <button
          onClick={() => setSystemInverted(!systemInverted)}
          className={cn(
            btn,
            systemInverted && "opacity-100 text-primary",
          )}
          title={systemInverted ? "System theme inverted" : "Invert system theme"}
        >
          <ArrowLeftRight size={16} />
        </button>
      )}
      <button
        onClick={cycleTheme}
        className={cn(btn)}
        title={`Theme: ${themePreference}`}
      >
        {themeIcon}
      </button>
    </div>
  );
}
